// extracted by mini-css-extract-plugin
module.exports = {"notification-show-page":"notification-show-page__3SL9k","back-button":"back-button__ivRZZ","title":"title__7nmPU","sub-title":"sub-title__2tFRA","content":"content__5lH3l"};